import { Message } from '@gonfalon/messages/Message';
// oxlint-disable-next-line no-restricted-imports
import { RequiredAsterisk } from '@launchpad-ui/core';

export const RequiredFieldsNotice = ({ singular = false }: { singular?: boolean }) => (
  <span className="u-fs-sm">
    <RequiredAsterisk /> <Message id="ui.requiredFields.notice" values={{ count: singular ? 1 : 2 }} />
  </span>
);
